import { render, staticRenderFns } from "./WelcomeToPica.vue?vue&type=template&id=73dd1ff4&"
import script from "./WelcomeToPica.vue?vue&type=script&lang=js&"
export * from "./WelcomeToPica.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeToPica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports